module.exports = __webpack_public_path__ + "static/media/icon_search_dark.2f356600.svg";